/*
 * Composable for change url custom on switchLocalePath
 */

export const useSetRouteParams = () => {
  const { $i18n } = useNuxtApp()
  const switchLocalePath = useSwitchLocalePath()
  const routeParams =
    useState<Record<typeof $i18n.locale.value, { slug: string }>>('routeParams')

  const setRouteParams = ({
    slugFr = '',
    slugEn = '',
  }: {
    slugFr: string
    slugEn: string
  }) => {
    routeParams.value = {
      en: { slug: slugEn },
      fr: { slug: slugFr },
    }
  }

  const getNewUrl = (localeCode: typeof $i18n.locale.value) => {
    const currentLocaleRouteSlug = routeParams.value?.[$i18n.locale.value]?.slug
    let nextLocaleRouteSlug = switchLocalePath(localeCode)?.split('?')[0]
    if (currentLocaleRouteSlug) {
      nextLocaleRouteSlug = nextLocaleRouteSlug.replace(
        currentLocaleRouteSlug,
        routeParams.value[localeCode].slug,
      )
    }

    return nextLocaleRouteSlug
  }

  return { getNewUrl, setRouteParams }
}
